import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaCaregiver } from "../../../models/api";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";
import { UtilityDate } from "../../../utils/dateUtils";

type Props = {
  data: ApiSchemaCaregiver | undefined;
  isValidating: boolean;
};

export const ImportantInfoCard = (props: Props) => {
  const { caregiverId } = useParams<{ caregiverId: string }>();

  return (
    <EditableCard
      title="Important info"
      link={`${AppRouteUi.Caregiver.Root()}/update/${caregiverId}`}
      isValidating={props.isValidating}
    >
      {props.isValidating ? (
        <TableCardPlaceholder rows={9} />
      ) : (
        <table className="w-100 ">
          {!!props.data?.userName && (
            <tr>
              <td className="p-3 border-bottom pe-2">Username</td>
              <td className="p-3 border-bottom ps-2">{props.data?.userName}</td>
            </tr>
          )}
          {!!props.data?.email && (
            <tr>
              <td className="p-3 border-bottom pe-2">Email Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.email}</td>
            </tr>
          )}
          {!!props.data?.phoneNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">Phone Number</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.phoneNumber}
              </td>
            </tr>
          )}
          {!!props.data?.address && (
            <tr>
              <td className="p-3 border-bottom pe-2">Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.address}</td>
            </tr>
          )}
          {!!props.data?.apartmentNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">Apartment</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.apartmentNumber}
              </td>
            </tr>
          )}
          {!!props.data?.dateOfBirth && (
            <tr>
              <td className="p-3 border-bottom pe-2">Date Of Birth</td>
              <td className="p-3 border-bottom ps-2">
                {UtilityDate.formatDate(props.data?.dateOfBirth)}
              </td>
            </tr>
          )}
          {!!props.data?.ssn && (
            <tr>
              <td className="p-3 border-bottom pe-2">Social security number</td>
              <td className="p-3 border-bottom ps-2">{props.data?.ssn}</td>
            </tr>
          )}
          {!!props.data?.champsIdNo && (
            <tr>
              <td className="p-3 border-bottom pe-2">Champ's id number</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.champsIdNo}
              </td>
            </tr>
          )}
          {!!props.data?.rate && (
            <tr>
              <td className="p-3 border-bottom pe-2">Rate</td>
              <td className="p-3 border-bottom ps-2">
                $ {props.data?.rate} per/unit
              </td>
            </tr>
          )}
          <tr>
            <td className="p-3 border-bottom pe-2">Languages(s)</td>
            <td className="p-3 border-bottom ps-2">
              {props.data?.languages?.length
                ? props.data?.languages?.join(", ")
                : "No Language"}
            </td>
          </tr>
          <tr>
            <td className="p-3 border-bottom pe-2">Transport</td>
            <td className="p-3 border-bottom ps-2">
              {!props.data?.isTransportAvailable && "Not"} Available
            </td>
          </tr>
          <tr>
            <td className="p-3 border-bottom pe-2">GPS Check In</td>
            <td className="p-3 border-bottom ps-2">
              {!props.data?.gpsCheckInTurnedOn && "Not"} Available
            </td>
          </tr>
        </table>
      )}
    </EditableCard>
  );
};
